<template>
  <div id="app">
    <BackNavBar v-if="showBackNav" :title="backTitle" />
    <section class="main-content" :class="{ 'login-page-content': !showNavBar }">
      <router-view></router-view>
    </section>
    <NavBar v-if="showNavBar"></NavBar>
  </div>
</template>

<script>
import NavBar from './components/navbar.vue'
import BackNavBar from './components/BackNavBar.vue'
import { isMainTab, SUB_ROUTE_TITLES } from './util/backNavigation'

export default {
  name: 'App',
  components: { NavBar, BackNavBar },
  computed: {
    showBackNav() {
      return !isMainTab(this.$route.path) && this.$route.path !== '/login'
    },
    showNavBar() {
      return this.$route.path !== '/login'
    },
    backTitle() {
      return SUB_ROUTE_TITLES[this.$route.path] || '返回'
    },
  },
}
</script>

<style>
html,body,#app{
  height: 100%;
}
#app{
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.main-content{
  flex: 1;
  min-height: 0;
  overflow: hidden;
  font-size: 14px;
}
.main-content.login-page-content{
  flex: 1;
  min-height: 0;
}

/* 确保 Vant 弹框遮罩覆盖底部导航 */
.van-overlay {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  z-index: 3000 !important;
}
.van-dialog {
  z-index: 3001 !important;
}
.van-popup {
  z-index: 3020 !important;
}

.add-fab {
  position: fixed;
  right: 16px;
  bottom: calc(60px + 16px);
  width: 48px;
  height: 48px;
  border: none;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: linear-gradient(180deg, #34c3ff 0%, #6ee7ff 100%);
  color: #fff;
  font-size: 30px;
  line-height: 1;
  font-weight: 300;
  box-shadow: 0 10px 24px rgba(52, 195, 255, 0.35);
  z-index: 10;
  cursor: pointer;
  font-family: inherit;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
}

.add-fab::after {
  content: "";
  position: absolute;
  inset: 4px;
  border-radius: 999px;
  background: radial-gradient(circle at 30% 25%, rgba(255, 255, 255, 0.75), transparent 55%);
  opacity: 0.65;
  pointer-events: none;
}

.add-fab:active {
  transform: scale(0.94);
}

/* Q版：全局弹框按钮/圆角（避免每页重复写） */
.van-dialog {
  border-radius: 18px !important;
  overflow: hidden;
}
.van-dialog__header {
  font-weight: 800;
  letter-spacing: 0.2px;
}
.van-dialog__footer {
  padding: 10px 10px 12px;
  background: rgba(255, 255, 255, 0.96);
}
.van-dialog__cancel,
.van-dialog__confirm {
  height: 40px;
  line-height: 40px;
  border-radius: 14px !important;
  margin: 0 6px;
  font-weight: 800;
}
.van-dialog__confirm {
  border: none !important;
  color: #fff !important;
  background: linear-gradient(180deg, #34c3ff 0%, #6ee7ff 100%) !important;
  box-shadow: 0 10px 20px rgba(52, 195, 255, 0.22);
}
.van-dialog__cancel {
  color: rgba(47, 52, 64, 0.9) !important;
  background: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid rgba(15, 23, 42, 0.10) !important;
  box-shadow: 0 8px 16px rgba(17, 24, 39, 0.08);
}
.van-dialog__confirm:active,
.van-dialog__cancel:active {
  transform: translateY(1px) scale(0.99);
}
</style>
